export type SiteConfig = typeof siteConfig
export const siteConfig = {
    name: "sprunksus",
    slogan: "slogan",
    icon: "/favicon.ico",
    appleIcon: "/apple-touch-icon.png",
    gameIframe: "https://www.youtube.com/embed/6LOHpRP_IZQ?si=XZHJJBQa0V4ug9y-",
    domain: "sprunksus.org",
    gaId: "G-EQPQLJKV4W",
    navbarItems: [
        {
            title: "title",
             href: "/",
        }
    ],
}
